export default __webpack_public_path__ + "static/media/order-download-icon.39d00c91.svg";